import React, {
    // useEffect, 
    useRef, useState
} from 'react';
import Modal from 'react-bootstrap/Modal';

// import { TableBody, TableRow, TableCell, 
//     // InputAdornment
// } from '@mui/material'
// ;
import axios from "axios";
import useTableScroll from "../useTableScroll";
import { Mensaje } from '../mensajes2';
import { Dimmer } from '../spinner';
import { DangerButton, SuccessButton } from '../../ui/buttons/Button';


const CambiarEfiscal = props => {

    let op = require('../../../src/modulos/datos');
    let token = localStorage.getItem('jwtToken');
    const efiscal = JSON.parse(localStorage.getItem('idefiscal'));

    const [values, setValues] = useState({});
    const [itemSelect, setItemSelect] = useState(-1);
    const [select, setSelect] = useState(false);
    const [mensaje, setMensaje] = useState({ mostrar: false, titulo: '', texto: '', icono: '' });
    // const [mensajesino, setMensajesino] = useState({ mostrar: false, titulo: '', texto: '', icono: '' });
    const [activate, setActivate] = useState(false);
    const [activo, setActivo] = useState(true);
    const [records, setRecords] = useState([]);
    const [filterFn, setFilterFn] = useState({ fn: items => { return items; } })
    const headCells = [
        { label: 'CÓDIGO', textAlign: 'center' },
        { label: 'DESCRIPCIÓN', textAlign: 'center' },
        { label: 'AÑO', textAlign: 'center' },
    ]
    const {
        TblContainer,
        TblHead,
        TblPagination,
        recordsAfterPagingAndSorting
    } = useTableScroll(records, headCells, filterFn);
    const handleSearch = e => {
        let target = e.target;
        setFilterFn({
            fn: items => {
                if (target.value === "") {
                    return items;
                } else {
                    return items.filter(x => {
                        if (x.idefiscal.includes(target.value)
                            || x.descriptor.toLowerCase().includes(target.value.toLowerCase())) {
                            return x;
                        }
                    });
                }
            }
        })
    }
    const seleccionarEjercicioFiscal = () => {
        setActivate(true);
        let campos = '*';
        let nomtab = 'efiscal';
        let orden = 'anio desc';
        let endpoint = `${op.conexion}/api/comun/seleccionaregistros?&campos=${campos}&nomtab=${nomtab}&orden=${orden}`;
        axios.get(endpoint, {
            headers: {
                "x-access-token": `${token}`,
                'Content-Type': 'application/json'

            },
        }).then(function (response) {
            if (response.status == 200) {
                setActivate(false);
                var clase = []
                for (let i = 0; i < response.data.length; i++) {
                    clase.push({
                        idefiscal: response.data[i].idefiscal,
                        descriptor: response.data[i].descriptor,
                        anio: response.data[i].anio,
                        observaciones: response.data[i].observaciones,
                        statusorg: response.data[i].statusorg,
                        statuspresup: response.data[i].statuspresup,
                        statuspuc: response.data[i].statuspuc,
                        statuscat: response.data[i].statuscat,
                        idorganizacion: response.data[i].idorganizacion,
                        activo: response.data[i].activo,
                    })
                }
                setRecords(clase)
            }
        }).catch(function (error) {
            setMensaje({ mostrar: true, titulo: 'Error', texto: mensaje, icono: 'error' });
            setActivate(false);
        })
    }
    const blanquear = () => {
        setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' })
        setItemSelect("");
        setActivate(false);
        setRecords([]);
        setActivo(true);
        setFilterFn({ fn: items => { return items; } });
    }
    const cancelar = () => {
        blanquear();
        if (props.onHideCancelar) props.onHideCancelar();
        if (props.setShow) props.setShow(false);
                props.setTabla()

    }

    const cerrarModal = () => {
        if (props.onHideCancelar) { props.onHideCancelar(); }
        if (props.setShow) props.setShow(false);
        props.setTabla()
        blanquear()
        setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' })
    }

    const seleccionarEfiscal = (event) => {
        event.preventDefault()
        var idefiscal = values[0].idefiscal;
        var descrip = values[0].descriptor;
        var anio = values[0].anio;
        var statusorg = values[0].statusorg;
        var statuspresup = values[0].statuspresup;
        var statuspuc = values[0].statuspuc;
        var statuscat = values[0].statuscat;

        localStorage.setItem('idefiscal', idefiscal);
        localStorage.setItem('efiscaldes', JSON.stringify(descrip));
        localStorage.setItem('efiscalanio', JSON.stringify(anio));
        localStorage.setItem('efiseleccionado', true);
        localStorage.setItem('statuspresup', JSON.stringify(statuspresup));
        localStorage.setItem('statuspuc', JSON.stringify(statuspuc));
        localStorage.setItem('statuscat', JSON.stringify(statuscat));
        localStorage.setItem('statusorg', JSON.stringify(statusorg));

        setMensaje({ mostrar: true, titulo: 'Exito.', texto: 'Cambio Realizado Exitosamente.', icono: 'exito' })
    };

    const seleccionarFila = (index) => (event) => {
        setItemSelect(index);
        setActivo(false);
        setSelect(parseInt(idefiscal));
        var idefiscal = recordsAfterPagingAndSorting()[index].idefiscal;
        var descriptor = recordsAfterPagingAndSorting()[index].descriptor;
        var anio = recordsAfterPagingAndSorting()[index].anio;
        var observaciones = recordsAfterPagingAndSorting()[index].observaciones;
        var statusorg = recordsAfterPagingAndSorting()[index].statusorg;
        var statuspresup = recordsAfterPagingAndSorting()[index].statuspresup;
        var statuspuc = recordsAfterPagingAndSorting()[index].statuspuc;
        var statuscat = recordsAfterPagingAndSorting()[index].statuscat;
        var idorganizacion = recordsAfterPagingAndSorting()[index].idorganizacion;
        var activo = recordsAfterPagingAndSorting()[index].activo;

        var datos = [];
        datos.push({
            idefiscal,
            descriptor,
            anio,
            observaciones,
            statusorg,
            statuspresup,
            statuspuc,
            statuscat,
            idorganizacion,
            activo
        })
        setValues(datos);
    };


    return (
        <Modal
            {...props}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
            style={{ backgroundColor: "rgb(0,0,0,0.5)" }}
            backdrop="static"
            keyboard={false}
            onShow={() => {
                seleccionarEjercicioFiscal();
                setSelect(parseInt(efiscal));
            }}
        >
            <Modal.Header className='header-azulGradiant'>
                <h3>Cambio del Ejercicio Fiscal.</h3>
                <a
                    type='button'
                    onClick={cancelar}>
                    salir<i className="fa fa-times"></i>
                </a>
            </Modal.Header>
            <Modal.Body>
                <Mensaje mensaje={mensaje}
                    onHide={() => mensaje.titulo === 'Exito.' ? cerrarModal() :
                        setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' })} />
                <Dimmer active={activate} inverted>

                </Dimmer>
                <div className="col-6 input-group input-group-sm m-0 mb-2 p-0">
                    <input type='text'
                        onChange={handleSearch} className="form-control search-input rounded-pill" />
                </div>
                <div className="col-12 m-0 p-0">
                    <TblContainer >
                        <TblHead />
                        <tbody>
                            {
                                records && recordsAfterPagingAndSorting().map((item, index) => (
                                    <tr key={item.idefiscal} style={{ padding: "0", cursor: 'pointer', backgroundColor: select === parseInt(item.idefiscal) ? "lightskyblue" : itemSelect === index ? "lightskyblue" : "white" }} onClick={seleccionarFila(index)}>
                                        <td className='py-2 text-center'>{item.idefiscal}</td>
                                        <td className='py-2 text-start'>{item.descriptor}</td>
                                        <td className='py-2 text-center'>{item.anio}</td>
                                    </tr>
                                ))
                            }
                        </tbody>
                    </TblContainer>
                    <TblPagination />
                </div>
            </Modal.Body>
            <Modal.Footer className='footer-azulGradiant'>
                <SuccessButton onClick={seleccionarEfiscal} disabled={activo}>
                    Aceptar
                </SuccessButton>
                <DangerButton onClick={cancelar}>
                    Cancelar
                </DangerButton>
            </Modal.Footer>
        </Modal>
    );
}
export default CambiarEfiscal;